<template>
    <form-modal
        :open="isEditModalOpen"
        :heading="$t('modals.recurringBill.edit')"
        entity="recurringBill"
        mode="edit"
        :submit-label="$t('modals.recurringBill.save')"
        :fields="fields"
        :values="bill"
        :info="[{ label: $t('fields.id'), value: bill.recurring_id }]"
        save-url="/edit-recurring-bill.php"
        :build-payload="buildPayload"
        @update:open="$emit('update:isEditModalOpen', $event)"
        @opened="load"
        @saved="$emit('bill-saved')"
    />
</template>

<script>
import { ref, computed } from 'vue';
import apiClient from '@/api/apiClient';
import { useSubcategoryOptions } from '@/composables/useSubcategoryOptions';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isEditModalOpen: {
            type: Boolean,
            required: true,
        },
        selectedBill: {
            type: Object,
            default: () => ({ recurring_id: null, subcategory_id: null, day: null, value: null, name: null, status: null }),
        },
    },
    emits: ['update:isEditModalOpen', 'bill-saved'],
    setup(props) {
        const bill = ref({});
        const { subcategoryGroups, fetchSubcategories } = useSubcategoryOptions();

        const fields = computed(() => [
            { key: 'subcategory_id', label: t('fields.subcategory'), type: 'select', required: true, placeholder: t('placeholders.selectSubcategory'), groups: subcategoryGroups.value },
            {
                key: 'day', label: t('fields.dayOfMonth'), type: 'number', required: true, min: 1, max: 31, digitsOnly: true,
                hint: t('hints.billDay')
            },
            { key: 'value', label: t('fields.value'), type: 'number', required: true },
            { key: 'name', label: t('fields.name'), type: 'text', required: true },
            { key: 'status', label: t('fields.active'), type: 'checkbox' },
        ]);

        const buildPayload = (form) => ({
            recurringId: form.recurring_id,
            subcat: form.subcategory_id,
            day: form.day,
            value: form.value,
            name: form.name,
            status: form.status,
        });

        const load = () => {
            bill.value = {};
            fetchSubcategories();
            apiClient.get('/get-recurring-bill-details.php?recurringId=' + props.selectedBill.recurring_id)
                .then((response) => {
                    bill.value = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching recurring bill details:', error);
                });
        };

        return { bill, fields, buildPayload, load };
    },
};
</script>
